export { Carousel } from './carousel.component';
